import React, { useRef, useState } from "react";

export default function Input({
  ...props
}: React.InputHTMLAttributes<HTMLInputElement> & {
  existingData?: any[] | undefined;
}) {
  const isMobile = () => window.innerWidth < 768;

  const element = useRef<HTMLInputElement>(null);
  const { existingData, ...inputProps } = props;
  const [currentValue, setCurrentValue] = useState(props.defaultValue);
  return (
    <div
      className={`flex  items-center w-full ${
        isMobile() ? "px-2 h-[10%]" : "h-[15%]"
      }`}
    >
      <datalist id={props.name + "-list"} className="hidden">
        {props.existingData
          ?.reduce((acc, data) => {
            if (
              data[props.name as keyof typeof data] &&
              !acc.some(
                (o) =>
                  o[props.name as keyof typeof data] ===
                  data[props.name as keyof typeof data]
              )
            ) {
              acc.push(data);
            }
            return acc;
          }, [] as any[])
          .sort((a, b) => {
            props.existingData!.filter(
              (o) =>
                o[props.name as keyof typeof o] ===
                a[props.name as keyof typeof a]
            ).length -
              props.existingData!.filter(
                (o) =>
                  o[props.name as keyof typeof o] ===
                  b[props.name as keyof typeof b]
              ).length;
          })
          .map((data) => (
            <option
              key={data.id}
              value={data[props.name as keyof typeof data]}
            />
          ))}
      </datalist>
      <div
        className={`relative flex items-center ${
          isMobile() ? "w-[100%]" : "w-[100%]"
        }`}
      >
        <div className="relative w-full">
          <input
            type="text"
            {...inputProps}
            onChange={(e) => {
              setCurrentValue(e.target.value);
              inputProps.onChange?.(e);
            }}
            className={`w-full border-2 p-2 pr-8 border-Grey4 rounded h-full ${
              (props as any)?.className
            }`}
            ref={element}
            list={props.name + "-list"}
          />
          {element.current?.value && element.current?.value.length > 0 && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                if (element.current) {
                  element.current.value = "";
                  setCurrentValue("");
                }
              }}
              type="button"
              className={`absolute right-2 top-1/2 -translate-y-1/2 text-PrimaryBlack hover:text-Grey4 transition-colors ${
                currentValue === "" ? "hidden" : ""
              }`}
              aria-label="Clear"
            >
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
